import { render, staticRenderFns } from "./previewAds.vue?vue&type=template&id=df23d868&scoped=true&"
import script from "./previewAds.vue?vue&type=script&lang=js&"
export * from "./previewAds.vue?vue&type=script&lang=js&"
import style0 from "./previewAds.vue?vue&type=style&index=0&id=df23d868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df23d868",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
